/* INDIA EC — interactions: theme toggle, scroll reveal, favorites, subtle particles */
(function () {
  'use strict';

  /* ---- Light / dark mode (sky blue × white light theme) ---- */
  function initTheme() {
    var KEY = 'ie_theme';
    var root = document.documentElement;
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    var theme = saved || 'light'; /* default: light (sky blue × white) */
    root.setAttribute('data-ie-theme', theme);

    if (document.querySelector('.ie-theme-toggle')) return;

    var ICONS =
      '<svg class="icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="12" cy="12" r="4.4"/><path d="M12 2.5v2.4M12 19.1v2.4M2.5 12h2.4M19.1 12h2.4M4.9 4.9l1.7 1.7M17.4 17.4l1.7 1.7M4.9 19.1l1.7-1.7M17.4 6.6l1.7-1.7"/></svg>' +
      '<svg class="icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 14.2A8.5 8.5 0 0 1 9.8 3.5a8.5 8.5 0 1 0 10.7 10.7z"/></svg>';

    function toggleTheme() {
      var next = root.getAttribute('data-ie-theme') === 'light' ? 'dark' : 'light';
      root.setAttribute('data-ie-theme', next);
      try { localStorage.setItem(KEY, next); } catch (e) {}
    }
    function makeBtn(withLabel) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ie-theme-toggle';
      b.setAttribute('aria-label', 'Toggle light / dark mode');
      b.innerHTML = ICONS + (withLabel ? '<span class="ie-toggle-label">Light / Dark</span>' : '');
      b.addEventListener('click', toggleTheme);
      return b;
    }

    /* Sit in Dawn's header icon row when it exists; float bottom-left otherwise */
    var icons = document.querySelector('.header__icons');
    if (icons) {
      var btn = makeBtn(false);
      btn.classList.add('ie-theme-toggle--header');
      var search = icons.querySelector('.header__icon--search, details-modal');
      if (search) icons.insertBefore(btn, search);
      else icons.insertBefore(btn, icons.firstChild);
    } else {
      document.body.appendChild(makeBtn(false));
    }

    /* below the nav breakpoint the header button is hidden, so mirror it
       inside the hamburger drawer */
    var drawerNav = document.querySelector('.menu-drawer__navigation');
    if (drawerNav && !drawerNav.querySelector('.ie-theme-toggle')) {
      var menu = drawerNav.querySelector('.menu-drawer__menu');
      var dBtn = makeBtn(true);
      if (menu && menu.parentNode) menu.parentNode.insertBefore(dBtn, menu.nextSibling);
      else drawerNav.appendChild(dBtn);
    }
  }

  /* ---- Header lifts off the page once scrolled ---- */
  function initHeaderScroll() {
    var hdr = document.querySelector('.header-wrapper');
    if (!hdr) return;
    var apply = function () { hdr.classList.toggle('ie-scrolled', window.scrollY > 8); };
    apply();
    window.addEventListener('scroll', apply, { passive: true });
  }

  /* ---- Auto-scrolling product carousels (hover pauses, drag/swipe to browse) ---- */
  function initCarousels() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-ie-carousel]').forEach(function (track) {
      if (track.dataset.ieCarouselReady) return;
      track.dataset.ieCarouselReady = '1';

      /* wrap so the arrows can sit outside the scrolling area */
      var shell = document.createElement('div');
      shell.className = 'ie-carousel-shell';
      track.parentNode.insertBefore(shell, track);
      shell.appendChild(track);

      var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>';
      var prev = document.createElement('button');
      var next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = 'ie-carousel-btn ie-carousel-btn--prev';
      next.className = 'ie-carousel-btn ie-carousel-btn--next';
      prev.setAttribute('aria-label', 'Previous items');
      next.setAttribute('aria-label', 'Next items');
      prev.innerHTML = ARROW;
      next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
      shell.appendChild(prev);
      shell.appendChild(next);

      function stepWidth() {
        var card = track.firstElementChild;
        if (!card) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function maxScroll() { return track.scrollWidth - track.clientWidth; }
      function syncArrows() {
        var atStart = track.scrollLeft < 4;
        var atEnd = track.scrollLeft >= maxScroll() - 4;
        prev.disabled = atStart && atEnd;
        next.disabled = atStart && atEnd;
      }

      function advance(dir) {
        var w = stepWidth();
        if (!w) return;
        var max = maxScroll();
        if (dir > 0 && track.scrollLeft >= max - 4) track.scrollTo({ left: 0 });
        else if (dir < 0 && track.scrollLeft < 4) track.scrollTo({ left: max });
        else track.scrollBy({ left: w * dir });
      }

      next.addEventListener('click', function () { advance(1); });
      prev.addEventListener('click', function () { advance(-1); });
      track.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
      syncArrows();

      /* autoplay */
      var paused = false;
      var delay = parseInt(track.getAttribute('data-delay'), 10) || 3500;
      if (!reduced && maxScroll() > 4) {
        setInterval(function () {
          if (paused || document.hidden || maxScroll() <= 4) return;
          advance(1);
        }, delay);
      }
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        track.addEventListener(ev, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (ev) {
        track.addEventListener(ev, function () { paused = false; });
      });
      track.addEventListener('touchend', function () {
        setTimeout(function () { paused = false; }, 2500);
      }, { passive: true });

      /* mouse drag (touch uses native scrolling).
         `is-dragging` disables pointer events on the cards, so it must only be
         applied once a real drag starts — adding it on mousedown would move the
         click target off the card link and swallow plain clicks. */
      var DRAG_THRESHOLD = 6;
      var down = false, startX = 0, startLeft = 0, moved = 0;
      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        down = true; moved = 0;
        startX = e.pageX; startLeft = track.scrollLeft;
      });
      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        var dx = e.pageX - startX;
        moved = Math.abs(dx);
        if (moved <= DRAG_THRESHOLD) return;
        track.classList.add('is-dragging');
        e.preventDefault();
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('mouseup', function () {
        if (!down) return;
        down = false;
        /* keep the class one tick longer so the click that follows a drag is
           still suppressed, then restore normal interaction */
        setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
      });
      /* a drag should never trigger the card link */
      track.addEventListener('click', function (e) {
        if (moved > DRAG_THRESHOLD) { e.preventDefault(); e.stopPropagation(); }
        moved = 0;
      }, true);
    });
  }

  /* ---- Catalog: live search + tab filters + sort (no page reloads) ---- */
  function initCatalog() {
    document.querySelectorAll('[data-ie-catalog]').forEach(function (root) {
      if (root.dataset.ieCatalogReady) return;
      root.dataset.ieCatalogReady = '1';

      var results = root.querySelector('[data-ie-results]');
      var items = Array.prototype.slice.call(root.querySelectorAll('.ie-catalog__item'));
      var countEl = root.querySelector('[data-ie-count]');
      var emptyEl = root.querySelector('[data-ie-empty]');
      var searchEl = root.querySelector('[data-ie-search]');
      var clearEl = root.querySelector('[data-ie-search-clear]');
      var sortEl = root.querySelector('[data-ie-sort]');
      if (!results) return;

      var state = { status: 'all', series: 'all', q: '', sort: 'featured' };
      var order = items.slice();

      function apply() {
        var q = state.q.trim().toLowerCase();
        var shown = 0;

        items.forEach(function (item) {
          var okStatus = state.status === 'all' ||
            (item.dataset.status || '').indexOf(state.status) !== -1;
          var okSeries = state.series === 'all' ||
            (item.dataset.series || '') === state.series;
          var okQuery = !q ||
            (item.dataset.title || '').indexOf(q) !== -1 ||
            (item.dataset.vendor || '').indexOf(q) !== -1 ||
            (item.dataset.series || '').indexOf(q) !== -1;
          var visible = okStatus && okSeries && okQuery;
          item.hidden = !visible;
          if (visible) shown++;
        });

        if (countEl) countEl.textContent = shown;
        if (emptyEl) emptyEl.hidden = shown !== 0;
        if (clearEl) clearEl.hidden = !state.q;
      }

      function sort() {
        var arr = order.slice();
        if (state.sort === 'price-asc') {
          arr.sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
        } else if (state.sort === 'price-desc') {
          arr.sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
        } else if (state.sort === 'title-asc') {
          arr.sort(function (a, b) { return (a.dataset.title || '').localeCompare(b.dataset.title || ''); });
        }
        arr.forEach(function (el) { results.appendChild(el); });
      }

      root.querySelectorAll('.ie-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var group = tab.getAttribute('data-filter');
          root.querySelectorAll('.ie-tab[data-filter="' + group + '"]').forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          state[group] = tab.getAttribute('data-value');
          apply();
        });
      });

      if (searchEl) {
        var timer = null;
        searchEl.addEventListener('input', function () {
          clearTimeout(timer);
          timer = setTimeout(function () { state.q = searchEl.value; apply(); }, 150);
        });
      }
      if (clearEl) {
        clearEl.addEventListener('click', function () {
          searchEl.value = ''; state.q = ''; apply(); searchEl.focus();
        });
      }
      if (sortEl) {
        sortEl.addEventListener('change', function () {
          state.sort = sortEl.value; sort(); apply();
        });
      }

      apply();
    });
  }

  /* ---- Product detail: gallery swap, quantity stepper, variant sync ---- */
  function initProduct() {
    /* gallery */
    document.querySelectorAll('[data-ie-gallery]').forEach(function (gal) {
      if (gal.dataset.ieGalleryReady) return;
      gal.dataset.ieGalleryReady = '1';
      var stage = gal.querySelector('[data-ie-stage]');
      var blur = gal.querySelector('.ie-pdp__blur');
      gal.querySelectorAll('.ie-pdp__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (stage) stage.src = thumb.getAttribute('data-full');
          if (blur) blur.src = thumb.getAttribute('data-blur');
          gal.querySelectorAll('.ie-pdp__thumb').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    });

    /* quantity stepper */
    document.querySelectorAll('.ie-qty').forEach(function (qty) {
      if (qty.dataset.ieQtyReady) return;
      qty.dataset.ieQtyReady = '1';
      var input = qty.querySelector('input');
      qty.querySelectorAll('[data-ie-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-ie-qty'), 10);
          var next = (parseInt(input.value, 10) || 1) + delta;
          input.value = next < 1 ? 1 : next;
        });
      });
    });

    /* variant select -> hidden id (keeps Add to Cart posting the right variant) */
    var form = document.querySelector('.ie-pdp__form');
    if (form && !form.dataset.ieVariantReady && window.ieVariants) {
      form.dataset.ieVariantReady = '1';
      var hidden = form.querySelector('input[name="id"]');
      var selects = form.querySelectorAll('[data-ie-option]');
      selects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
          var match = window.ieVariants.find(function (variant) {
            return variant.options.every(function (o, i) { return o === chosen[i]; });
          });
          if (match && hidden) hidden.value = match.id;
        });
      });
    }
  }

  /* ---- Cart: stepper buttons submit the quantity change straight away ---- */
  function initCart() {
    var form = document.querySelector('.ie-cart');
    if (!form || form.dataset.ieCartReady) return;
    form.dataset.ieCartReady = '1';

    form.querySelectorAll('[data-ie-cart-row]').forEach(function (row) {
      var input = row.querySelector('[data-ie-cart-qty]');
      if (!input) return;
      row.querySelectorAll('[data-ie-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-ie-qty'), 10);
          var next = (parseInt(input.value, 10) || 0) + delta;
          input.value = next < 0 ? 0 : next;
          form.classList.add('is-updating');
          form.requestSubmit
            ? form.requestSubmit(form.querySelector('[name="update"]'))
            : form.submit();
        });
      });
      /* typing a number and leaving the field commits it too */
      input.addEventListener('change', function () {
        form.classList.add('is-updating');
        form.requestSubmit
          ? form.requestSubmit(form.querySelector('[name="update"]'))
          : form.submit();
      });
    });
  }

  /* ---- Back links: go to the previous page when we came from this site ---- */
  function initBack() {
    document.querySelectorAll('[data-ie-back]').forEach(function (link) {
      if (link.dataset.ieBackReady) return;
      link.dataset.ieBackReady = '1';
      var internal = document.referrer &&
        document.referrer.indexOf(window.location.origin) === 0 &&
        document.referrer !== window.location.href;
      if (!internal) return; /* keep the href fallback for direct arrivals */
      link.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        history.back();
      });
    });
  }

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var els = document.querySelectorAll('.ie-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Favorite buttons (local, persists in localStorage) ---- */
  var FAV_KEY = 'ie_favorites';

  function favRead() {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) { raw = []; }
    if (!Array.isArray(raw)) return [];
    // migrate the old format (array of bare id strings) to objects
    return raw.map(function (x) { return typeof x === 'string' ? { id: x } : x; })
              .filter(function (x) { return x && x.id; });
  }
  function favWrite(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function favIndex(list, id) {
    for (var i = 0; i < list.length; i++) { if (list[i].id === id) return i; }
    return -1;
  }
  function favUpdateBadge() {
    var n = favRead().length;
    var count = document.querySelector('[data-ie-wishlist-count]');
    var bubble = document.querySelector('[data-ie-wishlist-bubble]');
    var link = document.querySelector('.header__icon--wishlist');
    if (count) count.textContent = n > 99 ? '99+' : n;
    if (bubble) bubble.hidden = n === 0;
    if (link) link.classList.toggle('is-active', n > 0);
  }

  function initFav() {
    var saved = favRead();
    document.querySelectorAll('.ie-fav').forEach(function (btn) {
      var id = btn.getAttribute('data-id') || '';
      if (!id) return;
      if (favIndex(saved, id) !== -1) btn.classList.add('is-active');
      if (btn.dataset.ieFavReady) return;
      btn.dataset.ieFavReady = '1';
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var list = favRead();
        var i = favIndex(list, id);
        if (i === -1) {
          list.push({
            id: id,
            url: btn.getAttribute('data-url') || '',
            title: btn.getAttribute('data-title') || '',
            img: btn.getAttribute('data-img') || '',
            sub: btn.getAttribute('data-sub') || '',
            price: btn.getAttribute('data-price') || '',
            cmp: btn.getAttribute('data-cmp') || ''
          });
          btn.classList.add('is-active');
        } else {
          list.splice(i, 1);
          btn.classList.remove('is-active');
        }
        favWrite(list);
        // keep every heart for this product in sync across the page
        document.querySelectorAll('.ie-fav[data-id="' + id + '"]').forEach(function (b) {
          b.classList.toggle('is-active', i === -1);
        });
        favUpdateBadge();
      });
    });
    favUpdateBadge();
  }

  function initWishlist() {
    var grid = document.querySelector('[data-ie-wishlist]');
    if (!grid) return;
    var empty = document.querySelector('[data-ie-wishlist-empty]');
    var clearBtn = document.querySelector('[data-ie-wishlist-clear]');

    function esc(s) { return (s || '').replace(/"/g, '&quot;'); }

    function render() {
      var list = favRead();
      grid.innerHTML = '';
      if (!list.length) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
        if (clearBtn) clearBtn.hidden = true;
        return;
      }
      grid.hidden = false;
      if (empty) empty.hidden = true;
      if (clearBtn) clearBtn.hidden = false;

      list.forEach(function (p) {
        var media = p.img
          ? '<img class="ie-card__blur" src="' + esc(p.img) + '" alt="" aria-hidden="true">' +
            '<img class="ie-card__img" src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">'
          : '<span class="ie-card__ph"></span>';
        var cmp = p.cmp ? '<span class="cmp">' + p.cmp + '</span>' : '';
        var sub = p.sub ? '<span class="ie-card__scale">' + p.sub + '</span>' : '';
        var card = document.createElement('div');
        card.className = 'ie-catalog__item';
        card.innerHTML =
          '<a href="' + esc(p.url) + '" class="ie-card">' +
            '<div class="ie-card__media">' + media + '</div>' +
            '<div class="ie-card__body">' +
              '<h3 class="ie-card__name">' + (p.title || '') + '</h3>' + sub +
              '<div class="ie-card__foot">' +
                '<span class="ie-card__price">' + (p.price || '') + cmp + '</span>' +
                '<button type="button" class="ie-fav is-active" aria-label="Remove from wishlist" data-id="' + esc(p.id) + '">' +
                  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</a>';
        card.querySelector('.ie-fav').addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var l = favRead();
          var i = favIndex(l, p.id);
          if (i !== -1) { l.splice(i, 1); favWrite(l); }
          render();
          favUpdateBadge();
        });
        grid.appendChild(card);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () { favWrite([]); render(); favUpdateBadge(); });
    }
    render();
  }

  /* ---- Subtle background particles (hero) ---- */
  function initParticles() {
    var host = document.querySelector('[data-ie-particles]');
    if (!host || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:-1;pointer-events:none;';
    host.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dots = [];
    var w, h;

    function resize() {
      w = canvas.width = host.offsetWidth;
      h = canvas.height = host.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    var count = Math.min(60, Math.floor(w / 26));
    for (var i = 0; i < count; i++) {
      dots.push({
        x: Math.random() * w, y: Math.random() * h,
        r: Math.random() * 1.8 + 0.4,
        vx: (Math.random() - 0.5) * 0.25,
        vy: (Math.random() - 0.5) * 0.25,
        a: Math.random() * 0.5 + 0.1
      });
    }
    function tick() {
      ctx.clearRect(0, 0, w, h);
      dots.forEach(function (d) {
        d.x += d.vx; d.y += d.vy;
        if (d.x < 0 || d.x > w) d.vx *= -1;
        if (d.y < 0 || d.y > h) d.vy *= -1;
        ctx.beginPath();
        ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
        var light = document.documentElement.getAttribute('data-ie-theme') === 'light';
        ctx.fillStyle = (light ? 'rgba(2,132,199,' : 'rgba(125,211,252,') + d.a + ')';
        ctx.fill();
      });
      requestAnimationFrame(tick);
    }
    tick();
  }

  function boot() { initTheme(); initHeaderScroll(); initCarousels(); initCatalog(); initProduct(); initCart(); initBack(); initReveal(); initFav(); initWishlist(); initParticles(); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Re-init in Shopify theme editor when sections reload
  document.addEventListener('shopify:section:load', function () { initCarousels(); initCatalog(); initProduct(); initCart(); initBack(); initReveal(); initFav(); initWishlist(); });
})();
